function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M360.9,35.2l84,84c4.1,4.1,4.1,10.7,0,14.8l-84,84c-6.6,6.6-17.9,1.9-17.9-7.4l0-63H11.3c-5.8,0-10.5-4.7-10.5-10.5v-21 c0-5.8,4.7-10.5,10.5-10.5H343l0-63C343,33.3,354.3,28.6,360.9,35.2z M176.7,266.1c0-9.3,11.3-14,17.9-7.4l84,84 c4.1,4.1,4.1,10.7,0,14.8l-84,84c-6.6,6.6-17.9,1.9-17.9-7.4l0-63h-165c-5.8,0-10.5-4.7-10.5-10.5v-21c0-5.8,4.7-10.5,10.5-10.5h165 L176.7,266.1z"
});

var SvgArrowTwo = function SvgArrowTwo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowTwo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-two.8363a168.svg";
export { ForwardRef as ReactComponent };